import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
const Layout = (props) => {
  let IsLoggedIn  =  localStorage.getItem("IsLoggedIn");
  return (
    props.auth?.accessToken || IsLoggedIn == "true" ? <Outlet /> : <Navigate to="/login" state={{ from: '/' }} replace />
  )
}
export default Layout